import {Permissions} from 'auth/PermissionConstants';
import SubtemplateActions from 'notebook/entry-templates/SubtemplateActions';
import TemplateActions from 'notebook/entry-templates/TemplateActions';
import APIUtil from 'util/APIUtil';
import {OngoingTaskResponse} from 'util/TaskRunner';

import {Review} from './ReviewConstants';

/**
 * Merges post-review-action server review and permissions into the template or sub-template store so
 * the editor lock path (writable → allowEdits → locked) and review banner update immediately after
 * send-for-review.
 */
export default function postTemplateReviewActionServerUpdate(
  templateId: string,
  review: Review,
  permissions: Permissions,
  _snapshotTask: OngoingTaskResponse | null
): void {
  if (APIUtil.isSubtemplate(templateId)) {
    SubtemplateActions.postServerUpdate(templateId, {review, permissions});
  } else {
    TemplateActions.postServerUpdate(templateId, {review, permissions});
  }
}
